import ENDPOINT from "@/api/endpoints";
import { HTTP, HTTP_QLVB, HTTP_COMMON, buildQueries, HTTP_FILE } from "@/api/http-common";
import _cloneDeep from "lodash/cloneDeep";
import { formatAttachFilesData } from "@/utils/uploadFileUtils";

const formDataHeaderConfig = {
  headers: {
    "Content-Type": "multipart/form-data;"
  }
};

function getFormDataFromPayload(payload) {
  let formData = new FormData();
  for (let key in payload) {
    if (["NhiemVuXuLy"].indexOf(key) === -1) {
      formData.append(key, payload[key]);
    }
  }
  const NhiemVuXuLy = _cloneDeep(payload.NhiemVuXuLy);

  NhiemVuXuLy.forEach((file, index) => {
    formData = formatAttachFilesData(file, index, formData, "NhiemVuXuLy");
  });

  return formData;
}

export function callApiSetCurrentDonVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.SET_CURRENT_DON_VI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const callApiGetDonViCurrentUser = () => {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.GET_DON_VI_CURRENT_USER)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const callApiGetPermissions = () => {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.PERMISSION)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export function callApiGetPhanHoiMoiNhat(payload) {
  return HTTP({
    url: ENDPOINT.COMMON.GET_PHAN_HOI_MOI,
    method: "GET",
    params: payload
  });
}

export function callApiSearchCanBo(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.SEARCH,
    method: "GET",
    params: payload
  });
}

export function callApiSearchLoaiVanBan(payload) {
  return HTTP({
    url: ENDPOINT.LOAI_VAN_BAN.SEARCH,
    method: "GET",
    params: payload
  });
}

export function callApiSearchLuong(payload) {
  return HTTP({
    url: ENDPOINT.LUONG.SEARCH,
    method: "GET",
    params: payload
  });
}

export function callApiThemLuong(payload) {
  return HTTP({
    url: ENDPOINT.LUONG.CREATE,
    method: "POST",
    data: payload
  });
}

export function callApiXoaLuong(payload) {
  return HTTP({
    url: ENDPOINT.LUONG.DELETE,
    method: "DELETE",
    data: payload
  });
}

export function callApiDownloadMultiFile(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.DOWNLOAD_MULTIFILE,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetMultiCanBo(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.GET_MULTI,
    method: "POST",
    data: payload
  });
}

export function callApiGetCanBoIgnore(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.SEARCH_IGNORE,
    method: "POST",
    data: payload
  });
}

export function callApiGetCanBoVanThu(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.SEARCH_VAN_THU,
    method: "GET",
    params: payload
  });
}

export function callApiGetAllSoDen(payload) {
  return HTTP({
    url: ENDPOINT.SO_VAN_BAN.GET_ALL,
    method: "GET",
    params: payload
  });
}

export function callApiGetAllSoDi(payload) {
  return HTTP({
    url: ENDPOINT.SO_VAN_BAN.GET_ALL_DON_VI,
    method: "GET",
    params: payload
  });
}

export function callApiGetAllSoDenTraCuu(payload) {
  return HTTP({
    url: ENDPOINT.SO_VAN_BAN.GET_ALL_TRA_CUU,
    method: "GET",
    params: payload
  });
}

export function callApiGetThongTinNguoiDung(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.CHI_TIET,
    method: "POST",
    data: payload
  });
}

export function callApiUpdateThongTinNguoiDung(payload) {
  return HTTP({
    url: `${ENDPOINT.CAN_BO.NAME}/${payload.id}${ENDPOINT.CAN_BO.UPDATE_CAN_BO}`,
    method: "POST",
    data: payload.data
  });
}

export function callApiUpdateAnhCaNhan(payload) {
  return HTTP_FILE({
    url: `${ENDPOINT.CAN_BO.NAME}${ENDPOINT.CAN_BO.UPDATE_ANH}`,
    method: "POST",
    data: payload
  });
}

export function callApiUploadAnhCanBo(payload) {
  return HTTP_COMMON({
    url: `/CanBo${ENDPOINT.CAN_BO.UPLOAD}`,
    method: "PATCH",
    data: payload
  });
}

// UC7.4: danh sách thiết bị xác thực của CHÍNH user (list-device self, read-only, không trả Secret).
// Response item camelCase: {deviceId, tenThietBi, os, state, isPrimary, ngayDangKy, lanDungCuoi}.
export function callApiListMyDevices() {
  return HTTP_COMMON.get(ENDPOINT.OTP_DEVICE.LIST_DEVICE);
}

// UC7.4: đặt 1 thiết bị Active làm chính. Body key DeviceId (khớp SetPrimaryModel C#). BE enforce invariant 1-primary/user.
export function callApiSetPrimaryDevice(deviceId) {
  return HTTP_COMMON.post(ENDPOINT.OTP_DEVICE.SET_PRIMARY, { DeviceId: deviceId });
}

// Self-service gỡ thiết bị kẹt ChoKichHoat (giải deadlock login-pending). Body PascalCase khớp SelfRevokeMyDeviceModel C#.
// KHÔNG gửi UserId (BE ép = _currentUser). TwoFactorCode = OTP hiện tại từ thiết bị Active. authorizerDeviceId optional
// (null -> BE fan-out verify mọi thiết bị Active). BE trả succeeded/message.
export function callApiRevokeMyDevice(deviceId, twoFactorCode, authorizerDeviceId) {
  return HTTP_COMMON.post(ENDPOINT.OTP_DEVICE.REVOKE_MY_DEVICE, {
    DeviceId: deviceId,
    TwoFactorCode: twoFactorCode,
    AuthorizerDeviceId: authorizerDeviceId || null,
  });
}

// Gỡ thiết bị Active CUỐI CÙNG -> BE tắt luôn 2FA về chưa-bật (xóa sạch Device + hủy mọi phiên sống).
// KHÁC callApiRevokeMyDevice: endpoint này KHÔNG nhận OTP (DTO SelfRevokeDeviceModel chỉ có DeviceId) vì
// user mất thiết bị duy nhất thì không thể có OTP -> bắt nhập = vòng lặp chết. Mật khẩu lúc login là factor.
// Gọi XONG phải đăng xuất: BE đã revoke refresh-token nên mọi request sau đó 401.
export function callApiSelfRevokeDevice(deviceId) {
  return HTTP_COMMON.post(ENDPOINT.OTP_DEVICE.SELF_REVOKE_DEVICE, { DeviceId: deviceId });
}

// UC7.4 (2026-08-19): mint QR ticket thêm thiết bị thứ N (post-login). Bearer full common-be trực tiếp.
// Body PascalCase khớp MintAddDeviceTicketModel C#. authorizerDeviceId optional (null -> BE fan-out mọi Active).
// BE trả camelCase {ticketId, expiresInSeconds} hoặc succeeded=false + message (gate OTP fail / đạt max thiết bị).
export function callApiMintAddDeviceTicket(twoFactorCode, authorizerDeviceId) {
  return HTTP_COMMON.post(ENDPOINT.OTP_DEVICE.MINT_ADD_DEVICE_TICKET, {
    AuthorizerOtp: twoFactorCode,
    AuthorizerDeviceId: authorizerDeviceId || null,
  });
}

// UC7.4: poll thiết bị đang chờ xác nhận (sau khi app quét QR + verify OTP). Bearer full. camelCase {hasPending, deviceId, tenThietBi}.
export function callApiGetPendingEnrollDevice() {
  return HTTP_COMMON.get(ENDPOINT.OTP_DEVICE.GET_PENDING_ENROLL);
}

// UC7.4: chốt binding thiết bị mới -> Active (channel-binding: chỉ phiên web này confirm được). Body {DeviceId}.
export function callApiConfirmEnrollBindingDevice(deviceId) {
  return HTTP_COMMON.post(ENDPOINT.OTP_DEVICE.CONFIRM_ENROLL_BINDING, { DeviceId: deviceId });
}

// Self-unlock qua email dự phòng (plan 260819-1524): user tự mở khóa thiết bị Locked của CHÍNH MÌNH (Bearer
// post-login, bằng thiết bị Active khác). Body PascalCase khớp SelfUnlockRequestModel/SelfUnlockConfirmModel C#.
// KHÔNG gửi UserId (BE ép = _currentUser, chống IDOR). BE trả succeeded/message. Bước 1: xin mã email.
export function callApiRequestMyUnlockCode(deviceId) {
  return HTTP_COMMON.post(ENDPOINT.OTP_DEVICE.REQUEST_MY_UNLOCK_CODE, { DeviceId: deviceId });
}

// Bước 2: nhập mã email dự phòng -> mở khóa đúng thiết bị Locked đã chọn (Locked->Active).
export function callApiConfirmMyUnlock(deviceId, code) {
  return HTTP_COMMON.post(ENDPOINT.OTP_DEVICE.CONFIRM_MY_UNLOCK, { DeviceId: deviceId, Code: code });
}

// Self-lock (đối chiếu D58): user tự KHÓA thiết bị Active của CHÍNH MÌNH (Active->Locked). Bearer post-login,
// KHÔNG email/OTP (đang cầm máy + đã login). Body PascalCase khớp SelfLockDeviceModel C#. KHÔNG gửi UserId (BE
// ép = _currentUser, chống IDOR). BE CHẶN khóa thiết bị Active cuối -> trả succeeded=false + message cảnh báo.
export function callApiLockMyDevice(deviceId) {
  return HTTP_COMMON.post(ENDPOINT.OTP_DEVICE.LOCK_MY_DEVICE, { DeviceId: deviceId });
}

export function callApiUpdateAnhCanBo(payload) {
  return HTTP_FILE({
    url: `${ENDPOINT.CAN_BO.NAME}/${payload.Id}${ENDPOINT.CAN_BO.UPDATE_ANH_CAN_BO_COMMON}`,
    method: "POST",
    data: payload
  });
}

export function callApiThemMoiFile(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.COMMON.UPLOAD_MULTI_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function callApiThemMoiFileHoSo(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.HSLT.LAP_HO_SO.UPLOAD_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDownloadFile(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.get(
      `${ENDPOINT.COMMON.DOWNLOAD_FILE}?fileId=${payload.id}&token=${payload.token}&isKySo=false`,
      {
        responseType: "blob"
      }
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDownloadFileQLVB(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_QLVB.get(
      `${ENDPOINT.COMMON.DOWNLOAD_FILE}?fileId=${payload.id}&token=&isKySo=false`,
      {
        responseType: "blob"
      }
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiAddQRCode(payload) {
  return HTTP_FILE({
    url: ENDPOINT.COMMON.ADD_QR_CODE,
    method: "POST",
    data: payload
  });
}

export const callApiPreviewFile = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(ENDPOINT.COMMON.PREVIEW_FILE, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const callApiGetFileInFolder = () => {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.get(ENDPOINT.COMMON.GET_FILE_IN_FOLDER)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export function callApiChenLuong(payload) {
  return HTTP({
    url: `${ENDPOINT.LUONG.INSERT}${payload.Id}`,
    method: "PUT",
    data: payload.data
  });
}
/* eslint-disable */
export const callApiScanVanBan = (payload) => {
  var formData = new FormData();
  payload.files.forEach((item) => {
    if (item.type === "folder") {
      item.items.forEach((itemChild) => {
        formData.append("file", itemChild);
      });
    } else {
      formData.append("file", item);
    }
  });
  formData.append("type", payload.type);
  return new Promise((resolve, reject) => {
    return HTTP.post(
      ENDPOINT.COMMON.SCAN_VAN_BAN,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const callApiGetAccessTokenFromIoC = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.get(`${ENDPOINT.COMMON.GET_ACCESS_TOKEN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const callApiGetImage = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.post(ENDPOINT.COMMON.GET_IMAGE, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const callApiKyDienTu = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.KY_DIEN_TU, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
}


export const callApiChangeGenerateSetupCode = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.GENERATE_SETUP_CODE_2FA, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve(error)
          reject(error);
        });
  });
}

export const callApiConfirmUsing = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.CONFIRM_USING_2FA, payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          resolve(error)
          reject(error);
        });
  });
}

// P2 QR handoff: mint enroll-ticket (token stage-1) -> {ticketId, expiresInSeconds} render QR.
export const callApiMintEnrollTicket = () => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.MINT_ENROLL_TICKET, {})
        .then((response) => { resolve(response); })
        .catch((error) => { resolve(error); reject(error); });
  });
}

// P2 QR handoff: poll pending enroll (token stage-1) -> {hasPending, deviceId, tenThietBi} để hiển thị xác nhận.
export const callApiGetPendingEnroll = () => {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.COMMON.AUTHENTICATOR.GET_PENDING_ENROLL)
        .then((response) => { resolve(response); })
        .catch((error) => { resolve(error); reject(error); });
  });
}

// P2 QR handoff: confirm-enroll-binding (channel-binding CRIT-2, token stage-1) -> Device Active.
export const callApiConfirmEnrollBinding = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.CONFIRM_ENROLL_BINDING, payload)
        .then((response) => { resolve(response); })
        .catch((error) => { resolve(error); reject(error); });
  });
}

// 1847 web QR-enroll email-verify: request mã kích hoạt email (token stage-1, qua proxy qlvb-be).
export const callApiOtpActivationRequest = () => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.OTP_ACTIVATION_REQUEST, {})
        .then((response) => { resolve(response); })
        .catch((error) => { reject(error); });
  });
}

// 1847 web QR-enroll email-verify: verify mã email -> BE đặt marker per-uid -> mint qua guard.
export const callApiOtpActivationVerify = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.OTP_ACTIVATION_VERIFY, payload)
        .then((response) => { resolve(response); })
        .catch((error) => { reject(error); });
  });
}

export const callApiValidateLogin = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.VALIDATE_2FA, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve(error)
          reject(error);
        });
  });
}

// Push Approval login (Phase 08). Poll trạng thái attempt qua qlvb-be forward (GET, kèm pollSecret query).
// Header Token = token stage-1 (cùng token dùng cho VALIDATE_2FA/CONFIRM_USING_2FA).
export const callApiPollLoginApproval = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.COMMON.AUTHENTICATOR.POLL_LOGIN_APPROVAL, { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
}

// Push Approval login (Phase 08). Hoàn tất đăng nhập sau khi poll thấy approved -> token 24h wrapper.
export const callApiCompleteLogin = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.COMPLETE_LOGIN, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
}

export function callApiGetAppId(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.get(`${ENDPOINT.COMMON.GET_APP_CODE}/${payload}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          resolve(error)
          reject(error);
        });
  });
}

export const callApiGetAccessToken = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.get(`${ENDPOINT.COMMON.GET_ACCES_TOKEN_IFRAME}?${buildQueries(payload)}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
  });
}

export const callApGetTreeDonVi = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.get(ENDPOINT.COMMON.DON_VI.GET_TREE, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error)
        reject(error);
      });
  });
}
